<div  *ngIf="popup && pfspo" class="mb-4">
  <h4 class="header mb-4">PFSPO Availability</h4>
  <b>Selected (PF)SPO:</b>
  <table class="nrk-table mb-4">
    <tr>
      <th>(PF)SPO#</th>
      <th>Pos</th>
      <th>Shipment</th>
      <th>EXW Date</th>
      <th>Vie Arrival</th>
      <th>PFSPO Status</th>
      <th>Transport Status</th>
      <th>Q</th>
      <th>assigned Q</th>
    </tr>
    <tr>
      <td>{{pfspo.code}}</td>
      <td>{{pfspo.pos}}</td>
      <td>{{this.pfspo.doc.directDelivery ? 'direct' : 'indirect'}}</td>
      <td>{{this.pfspo.doc.exwJapanDate | date : 'YYYY-MM-dd'}}</td>
      <td>{{this.pfspo.doc.arrivingVieDate | date : 'YYYY-MM-dd'}}</td>
      <td>{{spoStatus.get(this.pfspo.doc.transportRun?.spoStatus)?.name}}</td>
      <td>{{transportStatus.get(this.pfspo.doc.transportRun?.transportStatus)?.name}}</td>
      <td>{{this.pfspo.doc.lineItems[this.pfspo.pos-1]?.quantity}}</td>
      <td>{{getPfspoAssignedQ(lineItem)}}</td>
    </tr>
  </table>
</div>

<b>Assigned OCs to this (PF)SPO:</b>
<table class=" nrk-table spo-quantities mb-1">
  <tr>
    <th>Delivered Q: <span>{{getDeliveredQ(lineItem)}}</span></th>
    <th>Σ Assigned Q: <span>{{getAssignedQ(lineItem)}}</span></th>
    <th>Available Q: <span>{{getAvailableQ(lineItem)}}</span></th>
    <th>Free Q: <span>{{getFreeQ(lineItem)}}</span></th>
  </tr>
</table>
<table class="nrk-table">
  <tr>
    <!-- <th *ngIf="!disabled" style="text-align:center">
      <ngx-document-oc-selector
        [style]="{'left':'-5em','width':'75em'}"
        [filters]="[{'id':'productCode', 'search':lineItem.finishedProduct?.calcCode}]"
        (compilationChange)="onOcSelected(lineItem, $event)"
      ></ngx-document-oc-selector> -->
      <!-- <button class="nrk-doc-button" (click)="addOC(lineItem)">+</button></th> -->
    <th title="completely invoiced">INV</th>
    <th>OC#</th>
    <th style="text-align:center">OC Pos</th>
    <th style="text-align:right" title="OC line item quantity">Q</th>
    <!-- <th style="text-align:center">Unit</th> -->
    <th style="text-align:center">Dispatch date</th>
    <th style="text-align:center">ETA customer</th>
    <th style="text-align:center" title="customer requested delivery date">CRDD</th>
    <th style="text-align:center" title="customer accepted delivery date">CADD</th>
    <th title="assigned quantity">Assigned Q</th>
  </tr>
  <tr *ngFor="let oc of lineItem.relatedOCs; let lidx = index" [ngStyle]="oc.doc.code === compilation.code ? { 'background-color':'#bfb', 'border':'1px solid #aaa' } : null">
    <!-- <td *ngIf="!disabled" style="text-align:center"><button class="nrk-doc-button" (click)="removeOC(lineItem, lidx, spoPosition)">-</button></td> -->
    <td style="padding-left:0.8rem"><ngx-doc-form-checkbox [value]="oc.doc.completelyInvoiced" [disabled]="true"></ngx-doc-form-checkbox></td>
    <td><a [routerLink]="['/pages/erp/document/' + data.getIssuerFromCode(oc.doc.code)]"
      [queryParams]="{code: oc.doc.code}" >{{oc.doc | documentNumber}}</a></td>
    <td style="text-align:center">{{oc.pos}}</td>
    <td style="text-align:right">{{oc.doc.lineItems[oc.pos-1]?.quantity}}</td>
    <!-- <td style="text-align:center">{{unitData.get(oc.doc.lineItems[oc.pos-1]?.displayUnit)?.short}}</td> -->
    <td style="text-align:center;width:8rem" *ngIf="!disabled"><ngx-doc-form-date [(value)]="$any(oc).doc.vieDispatchDate" (valueChange)="api.updateField(oc.doc.code, 'vieDispatchDate', oc.doc.vieDispatchDate)"></ngx-doc-form-date></td>
    <td style="text-align:center" *ngIf="disabled">{{oc.doc.vieDispatchDate | date : 'yy-MM-dd'}}</td>
    <td style="text-align:center;width:8rem" *ngIf="!disabled"><ngx-doc-form-date [(value)]="$any(oc).doc.etaCustomerDate" (valueChange)="api.updateField(oc.doc.code, 'etaCustomerDate', oc.doc.etaCustomerDate)"></ngx-doc-form-date></td>
    <td style="text-align:center" *ngIf="disabled">{{oc.doc.etaCustomerDate | date : 'yy-MM-dd'}}</td>
    <td style="text-align:center">{{oc.doc.customerRequestedDeliveryDate | date : 'yy-MM-dd'}}</td>
    <td style="text-align:center">{{oc.doc.customerAcceptedDeliveryDate | date : 'yy-MM-dd'}}</td>
    <td><ngx-doc-form-texfield 
      [(value)]="$any(oc).quantity"
      (valueChange)="ocQuantityChanged(oc, lidx, $event)"
      [disabled]="oc.doc.code !== compilation.code || oc.doc.completelyInvoiced || disabled">
    </ngx-doc-form-texfield></td>
  </tr>
</table>

<div *ngIf="popup" class="row justify-content-center pt-4">
  <button *ngIf="!this.disabled" class="btn btn-success btn-md" (click)="save()">save</button>
  <button class="btn btn-danger btn-md" (click)="cancel()">cancel</button>
</div>